import { Component } from '@theme/component';
import { ConsentCollectedEvent, ThemeEvents } from '@theme/events';
import { getConsentStatus, setTrackingConsent } from '@theme/visitor-state';

class VisitorChoice extends Component {
  /** @type {AbortController | undefined} */
  #abortController;
  #pending = false;

  get #isPageMode() {
    return this.dataset.mode === 'page';
  }

  connectedCallback() {
    super.connectedCallback();

    if (!this.#isPageMode) return;

    this.#abortController = new AbortController();
    this.#showStatus();

    document.addEventListener(
      ThemeEvents.consentCollected,
      () => this.#showStatus(),
      { signal: this.#abortController.signal },
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
  }

  async #showStatus() {
    try {
      this.dataset.consentStatus = await getConsentStatus();
    } catch (error) {
      console.error('Customer Privacy API unavailable:', error);
    }
  }

  /** @param {boolean} busy */
  #setBusy(busy) {
    this.querySelectorAll('button').forEach((button) => {
      button.disabled = busy;
    });
  }

  accept() {
    return this.#record(true);
  }

  decline() {
    return this.#record(false);
  }

  /** @param {boolean} accepted */
  async #record(accepted) {
    if (this.#pending) return;

    this.#pending = true;
    this.#setBusy(true);

    try {
      await setTrackingConsent(accepted);
    } catch (error) {
      console.error('Customer Privacy API unavailable:', error);
      return;
    } finally {
      this.#pending = false;
      this.#setBusy(false);
    }

    if (!this.#isPageMode) this.remove();

    document.dispatchEvent(new ConsentCollectedEvent());
  }
}

if (!customElements.get('visitor-choice')) {
  customElements.define('visitor-choice', VisitorChoice);
}
